import { toast, ToastOptions } from "react-hot-toast";
import { Notification } from "components/alerts/Notifications";
import { INotificationProps } from "components/alerts/Notifications/Notification";

type TShowNotification = Omit<INotificationProps, "id"> & {
  toastOptions?: ToastOptions;
};

export const showNotification = ({
  toastOptions = {},
  ...notificationProps
}: TShowNotification) => {
  toast.custom((t) => (
    <Notification
      {...notificationProps}
      id={t.id}
    />
  ), toastOptions);
};
